<template>                          
  <AppHeaderDropdown right no-caret v-if="$store.state.currentUser.id">
    <template slot="header">
      <i class="icon-location-pin"></i>
    </template>
    <template slot="dropdown">
      <b-list-group style="width:400px">

        <b-list-group-item href="#" class="flex-column align-items-start">
          <b-dropdown-item><i class="icon-user-follow text-success"></i> New user registered</b-dropdown-item>
        </b-list-group-item>
        <b-list-group-item href="#" class="flex-column align-items-start">
          <b-dropdown-item><i class="icon-user-follow text-success"></i> New user registered</b-dropdown-item>
        </b-list-group-item>
        <b-list-group-item href="#" class="flex-column align-items-start">
          <b-dropdown-item><i class="icon-user-unfollow text-danger"></i> User deleted</b-dropdown-item>
        </b-list-group-item>
        <b-list-group-item href="#" class="flex-column align-items-start">
          <b-dropdown-item><i class="icon-chart text-info"></i> Sales report is ready</b-dropdown-item>
        </b-list-group-item>
        <b-list-group-item href="#" class="flex-column align-items-start">
          <b-dropdown-item><i class="icon-basket-loaded text-primary"></i> New client</b-dropdown-item>
        </b-list-group-item>
        <b-list-group-item href="#" class="flex-column align-items-start">
          <b-dropdown-item><i class="icon-speedometer text-warning"></i> Server overloaded</b-dropdown-item>
        </b-list-group-item>

        <b-list-group-item href="#" active class="flex-column align-items-start">
          <div class="d-flex w-100 justify-content-between">
            <h5 class="mb-1">Mensagens</h5>
            <small>7 mensagens</small>
          </div>
          <!--
          <p class="mb-1">
            Você tem 7 mensagens
          </p>
          -->
        </b-list-group-item>
        <b-list-group-item href="#" class="flex-column align-items-start">
          <div class="message">
            <div class="pt-3 mr-3 float-left">
              <div class="avatar">
                <img src="img/avatars/7.jpg" class="img-avatar" alt="admin@bootstrapmaster.com">
                <span class="avatar-status bg-success"></span>
              </div>
            </div>
            <div>
              <small class="text-muted">John Doe</small>
              <small class="text-muted float-right mt-1">Just now</small>
            </div>
            <div class="text-truncate font-weight-bold"><span class="fa fa-exclamation text-danger"></span> Important message</div>
            <div class="small text-muted text-truncate">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt...</div>
          </div>
        </b-list-group-item>
        <b-list-group-item href="#" class="flex-column align-items-start">
          <div class="message">
            <div class="pt-3 mr-3 float-left">
              <div class="avatar">
                <img src="img/avatars/7.jpg" class="img-avatar" alt="admin@bootstrapmaster.com">
                <span class="avatar-status bg-success"></span>
              </div>
            </div>
            <div>
              <small class="text-muted">John Doe</small>
              <small class="text-muted float-right mt-1">Just now</small>
            </div>
            <div class="text-truncate font-weight-bold"><span class="fa fa-exclamation text-danger"></span> Important message</div>
            <div class="small text-muted text-truncate">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt...</div>
          </div>
        </b-list-group-item>
        <b-list-group-item href="#" disabled class="flex-column align-items-start">
          <div class="d-flex w-100 justify-content-between">
            <h5 class="mb-1">Disabled List group item</h5>
            <small class="text-muted">3 days ago</small>
          </div>
          <p class="mb-1">
            Donec id elit non mi porta gravida at eget metus. Maecenas
            sed diam eget risus varius blandit.
          </p>
          <small class="text-muted">Donec id elit non mi porta.</small>
        </b-list-group-item>

        <b-list-group-item href="#" class="flex-column align-items-start">
          <div class="small mb-1">Upgrade NPM &amp; Bower <span class="float-right"><strong>0%</strong></span></div>
          <b-progress height={} class="progress-xs" variant="info" :value="0"/>
        </b-list-group-item>

        <b-list-group-item href="#" class="flex-column align-items-start">
          <div class="small mb-1">ReactJS Version <span class="float-right"><strong>25%</strong></span></div>
          <b-progress height={} class="progress-xs" variant="danger" :value="25"/>
        </b-list-group-item>

        <b-list-group-item href="#" class="flex-column align-items-start">
          <div class="text-uppercase mb-1">
            <small><b>CPU Usage</b></small>
          </div>
          <b-progress height={} class="progress-xs" variant="info" :value="25"/>
          <small class="text-muted">348 Processes. 1/4 Cores.</small>
        </b-list-group-item>
        
        <b-list-group-item href="#" class="flex-column align-items-start">
          <div class="text-uppercase mb-1">
            <small><b>Memory Usage</b></small>
          </div>
          <b-progress height={} class="progress-xs" variant="warning" :value="70"/>
          <small class="text-muted">11444GB/16384MB</small>
        </b-list-group-item>

        <b-list-group-item href="#" class="flex-column align-items-start">
          <div class="text-uppercase mb-1">
            <small><b>SSD 1 Usage</b></small>
          </div>
          <b-progress height={} class="progress-xs" variant="danger" :value="90"/>
          <small class="text-muted">243GB/256GB</small>
        </b-list-group-item>


      </b-list-group>
    </template>
  </AppHeaderDropdown>
</template>

<script>
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'
export default {
  name: 'DefaultHeaderDropdown',
  components: {
    AppHeaderDropdown
  }
}
</script>

